// extracted by mini-css-extract-plugin
export default {"container":"styles_container__RgE0h","chatContainer":"styles_chatContainer__N9hj9","configurationPanelContainer":"styles_configurationPanelContainer__u3cri"};